import React from "react";
import { Container } from "reactstrap";
//@ts-ignore
import logo from "../../assets/logo-white.png";
import { Link } from "react-router-dom";

export const TermsAndConditions = () => {
  document.title = "Casino24 - Terms & Conditions";
  return (
    <Container
      fluid
      className="m-0 flex flex-col min-h-full w-full items-center text-white"
    >
      <section className="w-full lg:w-[75%] lg:mt-[2rem] mb-1">
        <Link to="/">
          <img
            src={logo}
            alt="Casino24"
            className="object-cover w-[10rem] lg:w-[15rem] my-3 cursor-pointer"
          />
        </Link>
      </section>
      <section className="flex flex-col w-[90%] lg:w-[50%] xl:w-[37%] my-2 text-justify text-md ">
        <h2 className="text-center font-bold text-2xl xl:text-3xl mt-4">
          Term & Conditions
        </h2>
        <p className="mb-5 mt-5">
          These Terms and Conditions (“Terms”, “Terms and Conditions”) govern
          your relationship with Casinob8.com website (the “Service”) operated
          by Hype Grow, Unipessoal Lda (“us”, “we”, or “our”).
        </p>
        <p className="mb-5 text-lg font-bold">
          Please read these Terms and Conditions carefully before using the
          Service.
        </p>
        <p className="mb-5">
          Your access to and use of the Service is conditioned on your
          acceptance of and compliance with these Terms. These Terms apply to
          all visitors, users and others who access or use the Service.
        </p>
        <p className="mb-5">
          By accessing or using the Service you agree to be bound by these
          Terms. If you disagree with any part of the terms then you may not
          access the Service.
        </p>
        <p className="mb-5 font-bold">Content</p>
        <p className="mb-5">
          Our Service allows you to post, link, store, share and otherwise make
          available certain information, text, graphics, videos, or other
          material (“Content”). You are responsible for the Content that you
          post to the Service, including its legality, reliability, and
          appropriateness.
        </p>
        <p className="mb-5">
          By posting Content to the Service, you grant us the right and license
          to use, modify, publicly perform, publicly display, reproduce, and
          distribute such Content on and through the Service. You retain any and
          all of your rights to any Content you submit, post or display on or
          through the Service and you are responsible for protecting those
          rights. You agree that this license includes the right for us to make
          your Content available to other users of the Service, who may also use
          your Content subject to these Terms.
        </p>
        <p className="mb-5">
          You represent and warrant that: (i) the Content is yours (you own it)
          or you have the right to use it and grant us the rights and license as
          provided in these Terms, and (ii) the posting of your Content on or
          through the Service does not violate the privacy rights, publicity
          rights, copyrights, contract rights or any other rights of any person.
        </p>
        <p className="mb-5 font-bold">Intellectual Property</p>
        <p className="mb-5">
          The Service and its original content (excluding Content provided by
          users), features and functionality are and will remain the exclusive
          property of <b>Hype Grow, Unipessoal Lda</b> and its licensors. The
          Service is protected by copyright, trademark, and other laws of both
          Bulgaria and foreign countries. Our trademarks and trade dress may not
          be used in connection with any product or service without the prior
          written consent of <b>Hype Grow, Unipessoal Lda.</b>
        </p>
        <p className="mb-5 font-bold">Links to Other Web Sites</p>
        <p className="mb-5">
          Our Service contains links to third-party web sites or services that
          are not owned or controlled by <b>Hype Grow, Unipessoal Lda.</b>
        </p>
        <p className="mb-5">
          <b>Hype Grow, Unipessoal Lda</b> has no control over and assumes no
          responsibility for, the content, privacy policies, or practices of any
          third-party web sites or services. You further acknowledge and agree
          that Hype Grow, Unipessoal Lda shall not be responsible or liable,
          directly or indirectly, for any damage or loss caused or alleged to be
          caused by or in connection with use of or reliance on any such
          content, goods or services available on or through any such web sites
          or services.
        </p>
        <p className="mb-5">
          We strongly advise you to read the terms and conditions and privacy
          policies of any third-party web sites or services that you visit.
        </p>
        <p className="mb-5 font-bold">Termination</p>
        <p className="mb-5">
          We may terminate or suspend your account immediately, without prior
          notice or liability, for any reason whatsoever, including without
          limitation if you breach the Terms.
        </p>
        <p className="mb-5">
          Upon termination, your right to use the Service will immediately
          cease. If you wish to terminate your account, you may simply
          discontinue using the Service.
        </p>
        <p className="mb-5 font-bold">Limitation of Liability</p>
        <p className="mb-5">
          In no event shall <b>Hype Grow, Unipessoal Lda</b>, nor its directors,
          employees, partners, agents, suppliers, or affiliates, be liable for
          any indirect, incidental, special, consequential or punitive damages,
          including without limitation, loss of profits, data, use, goodwill, or
          other intangible losses, resulting from (i) your access to or use of
          or inability to access or use the Service; (ii) any conduct or content
          of any third party on the Service; (iii) any content obtained from the
          Service; and (iv) unauthorized access, use or alteration of your
          transmissions or content, whether based on warranty, contract, tort
          (including negligence) or any other legal theory, whether or not we
          have been informed of the possibility of such damage, and even if a
          remedy set forth herein is found to have failed of its essential
          purpose.
        </p>
        <p className="mb-5 font-bold">Disclaimer</p>
        <p className="mb-5">
          Your use of the Service is at your sole risk. The Service is provided
          on an “AS IS” and “AS AVAILABLE” basis. The Service is provided
          without warranties of any kind, whether express or implied, including,
          but not limited to, implied warranties of merchantability, fitness for
          a particular purpose, non-infringement or course of performance.
        </p>
        <p className="mb-5">
          <b>Hype Grow, Unipessoal Lda</b> its subsidiaries, affiliates, and its
          licensors do not warrant that a) the Service will function
          uninterrupted, secure or available at any particular time or location;
          b) any errors or defects will be corrected; c) the Service is free of
          viruses or other harmful components, or d) the results of using the
          Service will meet your requirements.
        </p>
        <p className="mb-5 font-bold">Governing Law</p>
        <p className="mb-5">
          These Terms shall be governed and construed in accordance with the
          laws of Bulgaria, without regard to its conflict of law provisions.
        </p>
        <p className="mb-5">
          Our failure to enforce any right or provision of these Terms will not
          be considered a waiver of those rights. If any provision of these
          Terms is held to be invalid or unenforceable by a court, the remaining
          provisions of these Terms will remain in effect. These Terms
          constitute the entire agreement between us regarding our Service and
          supersede and replace any prior agreements we might have between us
          regarding the Service.
        </p>
        <p className="mb-5 font-bold">Changes</p>
        <p className="mb-5">
          We reserve the right, at our sole discretion, to modify or replace
          these Terms at any time. If a revision is a material, we will try to
          provide at least 30 days notice prior to any new terms taking effect.
          What constitutes a material change will be determined at our sole
          discretion.
        </p>
        <p className="mb-5">
          By continuing to access or use our Service after those revisions
          become effective, you agree to be bound by the revised terms. If you
          do not agree to the new terms, please stop using the Service.
        </p>
        <p className="mb-5 font-bold">Contact Us</p>
        <p className="mb-5">
          If you have any questions about these Terms, please contact us.
        </p>
      </section>
    </Container>
  );
};
